import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit,ViewEncapsulation, ViewChild, TemplateRef, Output, EventEmitter } from '@angular/core';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { ImportDialogFileComponent } from '../import-dialog-file/import-dialog-file.component';
import { MatDialog} from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { RecipientsSearchService } from '../search/recipients-search.service';
import { RecipientsFilterService } from '../filter/recipients-filter.service';
import { OneSnackBarService, OneSnackBarType } from '@one/angular-kit/modal';
import { OneDialogConfirmationService } from '@one/angular-kit/modal';
import { QnSbnDataService } from '../../../services/qn-sbn-data-service.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MatPaginator } from '@angular/material/paginator';
import { AfterViewInit } from '@angular/core';
import { RexisSapDialogComponent } from '../../../rexis-sap-dialog/rexis-sap-dialog.component';
import { RecipientsTableService } from './recipients-table.service';

export interface RecipientModal{
  recipientListTable:[];
  sourceName:[];
}

export interface AppState {
  readonly recipientsState: RecipientModal[];
}

@Component({
  selector: 'dl-recipients-table',
  templateUrl: './recipients-table.component.html',
  styleUrls: ['./recipients-table.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('detailExpand', [
      state('collapsed, void', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
      transition('expanded <=> void', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})

export class RecipientsTableComponent implements OnInit, AfterViewInit {
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('myTemplate') recipientTemplate: TemplateRef<any>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  private _liveAnnouncer: any;
  public fileData = [];
  public emptyContactList: any;
  public columnData: any;
  public displayedColumns = ['select', 'customerId', 'customerName', 'customerContactName', 'customerEmail', 'sourceName', 'expandTrigger'];
  public dataSource = new MatTableDataSource<any>(this.fileData);
  public selection = new SelectionModel(true, []);
  public selectedRow: any;
  public filterArray: any[] = [];
  public tableData: any[] = [];
  public isDeleteBtnDisabled = true;
  public dataTobestore: Observable<RecipientModal[]>;
  public sourceNameForStore=[];
  public recipientData$: Observable<any>;
  public expandedElement: any;
  public isEmail: boolean = false;
  public isName: boolean = false;
  public contactLimitNumber: number = 5000;
  public isImportBtnExpanded = false;
  public newDataArr:any=[];
  public mainAccounts:any=[];
  public accountsAndContactsStats:any=[];
  @Output() public isLimit = new EventEmitter<boolean>();
  @Output() public isWarn = new EventEmitter<boolean>();
  @Output() public dataCount = new EventEmitter<[number,number]>();

  public constructor(
    private changeDetectorRef: ChangeDetectorRef, 
    private readonly dialog: MatDialog,
    private recipientsFilterService: RecipientsFilterService, 
    private recipientsSearchService: RecipientsSearchService, 
    private recipientsTableService: RecipientsTableService,
    private readonly oneSnackBar: OneSnackBarService, 
    private confirmationDialog: OneDialogConfirmationService,
    private _QnSbnDataService:QnSbnDataService
  ){}


  
  public ngOnInit(): void {

    this._QnSbnDataService.mappingData$.subscribe(observer=>{  
     if(!this._QnSbnDataService.isEmpty(observer['recipientData'])){
        this.dataSource.data = observer['recipientData']['recipientTable'];
        const allAccounts = this.dataSource.data.map(i => i.customerId);
        this.mainAccounts = [...new Set(allAccounts)];
        this.accountsAndContactsStats=[this.dataSource.data.length,this.mainAccounts.length]
        this.recipientsTableService.data(this.dataSource.data)
        this.dataSource.paginator = this.paginator;
        this.tableData = observer['recipientData']['recipientTable'];
        this.sourceNameForStore = observer['recipientData']['sourceName'];
        this.trimSpaces(this.dataSource.data)
        this.trimSpaces(this.tableData)
      }
    })

    this.recipientsSearchService.searchData$.subscribe(searchValue => {
      this.dataSource.filter = searchValue;
      this.dataSource.filterPredicate = (data: any, filter: string) => {
        return data.customerId.toLowerCase().includes(filter.toLowerCase()) || data.customerName.toLowerCase().includes(filter.toLowerCase()) || data.customerContactName.toLowerCase().includes(filter.toLowerCase()) || data.customerEmail.toLowerCase().includes(filter.toLowerCase());
      };
    });
    
    this.recipientsFilterService.filterData$.subscribe((searchValue: any[]) => {
      if (searchValue[0].length < 1) {
          this.recipientsTableService.setFilteredData(this.tableData)
          this.changeDetectorRef.detectChanges();
      }
      else {
        if(searchValue[1].length!=0){
          searchValue[0].forEach(ele => {
          if (ele) {
            this.tableData.map(x => {
              if (x.sourceName && (x.sourceName.trim().toLowerCase() === ele)) {
                this.filterArray.push(x);
              }
            });
            this.dataSource.data = this.filterArray;
            this.recipientsTableService.setFilteredData(this.filterArray)
            this.changeDetectorRef.detectChanges();
          }
        });
        }
        else{
          searchValue[0].forEach(ele => {
          if (ele) {
            this.tableData.map(x => {
              if (x.sourceName && (x.sourceName.trim().toLowerCase() === ele)) {
                this.filterArray.push(x);
              }
            });
            this.dataSource.data = this.filterArray;
            this.recipientsTableService.setFilteredData(this.filterArray)
            this.changeDetectorRef.detectChanges();
          }
          });
        }
        this.filterArray = [];
      }
    });

    this.recipientsFilterService.warningfilterData$.subscribe(searchValue => {
      this.dataSource.data=searchValue;
      this.changeDetectorRef.detectChanges();
    });

    this.dataSource.data=this.tableData;

    if(this.dataSource.data.length>0){
      const allAccounts = this.dataSource.data.map(i => i.customerId);
      this.mainAccounts = [...new Set(allAccounts)];
      this.accountsAndContactsStats=[this.dataSource.data.length,this.mainAccounts.length]
      this.dataCount.emit(this.accountsAndContactsStats);
    }else{
      this.dataCount.emit([0,0]);
    }

    if(this.dataSource.data.length <= this.contactLimitNumber){
      this.isLimit.emit(false);
    }else{
      this.isLimit.emit(true);
    }
    
    const duplicates = this.findDuplicates(this.dataSource.data);
    const emptyFields = this.findEmpties(this.dataSource.data);
    if(duplicates.length > 0 || emptyFields.length > 0){
      this.isWarn.emit(true);
    }else{
      this.isWarn.emit(false);
    }
  }
  
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  public isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;
    const numDisabled = this.dataSource.data.filter(row => row.disabled).length;
    const numRows = this.dataSource.data.length;
    return numSelected + numDisabled === numRows;
  }

  public masterToggle(): void {
    this.isAllSelected() ? this.selection.clear() : this.dataSource.data.forEach(row => (!row.disabled ? this.selection.select(row) : ''));
  }

  public addProduct(newData,sourcName) {
    this._QnSbnDataService.getMappedQnsbnData({ 
        recipientTable: newData,
        sourceName:sourcName
      },"Recipient")
  }

  public openDialog(): void {
    this.isImportBtnExpanded = false;
    const dialogRef = this.dialog.open(ImportDialogFileComponent, {
      data: { fileData: this.fileData, columnData: this.columnData },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.fileData = result.fileData;
      this.columnData = result.columnData;
      this.emptyContactList = this.validateContactList(this.fileData);
      if (this.emptyContactList.emptyDataRow && this.emptyContactList.emptyDataRow.length > 0) {
        const dialogRefEmpty = this.dialog.open(this.recipientTemplate, {
          data: { source: this.emptyContactList },
          disableClose: true
        });
        dialogRefEmpty.afterClosed().subscribe(result => {
          return;
        });
        return;
      }
      if(this.fileData != undefined){
        
        this.dataSource.data = [
          ...this.dataSource.data,
          ...this.fileData.map(data => {
            return {
              customerId: (data[this.columnData.Customer_ID])?(data[this.columnData.Customer_ID]).trim():'',
              customerName: (data[this.columnData.Customer_name])?(data[this.columnData.Customer_name]).trim():'',
              customerContactName: (data[this.columnData.Customer_contact_name])?(data[this.columnData.Customer_contact_name]).trim():'',
              customerEmail: (data[this.columnData.Customer_contact_email])?(data[this.columnData.Customer_contact_email]).trim():'',
              sourceName: (result.sourceName)?(result.sourceName):''
            };
          })
        ];
        if(this.dataSource.data.length <= this.contactLimitNumber){
          this.isLimit.emit(false);
        }else{
          this.isLimit.emit(true);
        }
        if(this.dataSource.data.length>0){
          const allAccounts = this.dataSource.data.map(i => i.customerId);
          this.mainAccounts = [...new Set(allAccounts)];
          this.accountsAndContactsStats=[this.dataSource.data.length,this.mainAccounts.length]
          this.dataCount.emit(this.accountsAndContactsStats);
        }else{
          this.dataCount.emit([0,0]);
        }
        const duplicates = this.findDuplicates(this.dataSource.data);
        const emptyFields = this.findEmpties(this.dataSource.data);
        if(duplicates.length > 0 || emptyFields.length > 0){
          this.isWarn.emit(true);
        }else{
          this.isWarn.emit(false);
        }
        this.recipientsFilterService.setSourceName(result.sourceName);
        this.sourceNameForStore = Object.assign([], this.sourceNameForStore);
        let sourceEle = {label: result.sourceName, value: result.sourceName};
        if (sourceEle.label !== '') {
            let checkEle = true;
            this.sourceNameForStore.some((el) => {
              if (el.label.trim().toLowerCase() === sourceEle.label.trim().toLowerCase()) {
                checkEle = false;
              }
            });
            if (checkEle) this.sourceNameForStore.push(sourceEle);
        }      
        this.tableData = this.dataSource.data;
        this.addProduct(this.dataSource.data,this.sourceNameForStore);
        if (this.dataSource.data.length > 0) {
          this.oneSnackBar.open('Recipient list imported successfully', OneSnackBarType.SUCCESS);
        }
      } else {
        this.oneSnackBar.open('There is some problem with recipient list', OneSnackBarType.WARNING);
      }
    });
  }

  public validateContactList(contactList: any) {
    let invalidRecordIndex = [];
    let customEmptyData = [];
    const emptyRecords = contactList.filter((item, i) => {
      if (!item[this.columnData.Customer_contact_email] || 
      item[this.columnData.Customer_contact_email].trim() === '') {
        customEmptyData.push(
          {
            rowIndex: i+1,
            customerId: (item[this.columnData.Customer_ID])?(item[this.columnData.Customer_ID]).trim():'',
            customerName: (item[this.columnData.Customer_name])?(item[this.columnData.Customer_name]).trim():'',
            customerContactName: (item[this.columnData.Customer_contact_name])?(item[this.columnData.Customer_contact_name]).trim():''
          }
        );
        return item;
      };
    });
    const invalidData = {
      emptyData: emptyRecords,
      emptyDataRow: customEmptyData
    };
    return invalidData;
  }

  public closeEmptyAlertDialog() {
    this.dialog.closeAll();
  }

  public validateBtnDeleteState(): void {
    this.isDeleteBtnDisabled = this.selection.selected.length > 0 ? false : true;
  }

  public openDeleteConfirmDialog(): void {
    const deleteDialogRef = this.confirmationDialog.open('Delete Recipient', 'Are you sure, you want to delete this recipient from recipients list?', 'Yes, delete', 'Cancel');

    deleteDialogRef.addPanelClass('rcp-delete-dialog');

    deleteDialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        const arrSelectedCustomerId: string[] = this.selection.selected;      
        this.dataSource.data = this.dataSource.data.filter(data =>{     
          return  !arrSelectedCustomerId.includes(data);    
        });
        this.tableData = this.tableData.filter(data => !arrSelectedCustomerId.includes(data));
        if(this.tableData.length==0){
          this.recipientsTableService.dataStatus([])
        }
        this.selection = new SelectionModel<any>(true, []);
        this.isDeleteBtnDisabled = true;
        let srcList=[];
        this.tableData.filter(d=>{  
          let srcEle = true;
          srcList.some((el) => {
            if (el.label.trim().toLowerCase() === d.sourceName.trim().toLowerCase()) {
              srcEle = false;
              this.expandToggle(el);
            }
          });
          if(srcEle){
            if(d.sourceName){
              srcList.push({label:d.sourceName, value: d.sourceName})
            }
          }
          return;
        })
        this.sourceNameForStore = Object.assign([], this.sourceNameForStore);
        this.sourceNameForStore = srcList;
        this.dataSource.data = this.tableData;
        this.addProduct(this.dataSource.data,this.sourceNameForStore);

        this.changeDetectorRef.detectChanges();
        this.oneSnackBar.open('Recipient deleted successfully', OneSnackBarType.SUCCESS);
        if(this.dataSource.data.length <= this.contactLimitNumber){
          this.isLimit.emit(false);
        }else{
          this.isLimit.emit(true);
        }
        if(this.dataSource.data.length>0){
          const allAccounts = this.dataSource.data.map(i => i.customerId);
          this.mainAccounts = [...new Set(allAccounts)];
          this.accountsAndContactsStats=[this.dataSource.data.length,this.mainAccounts.length]
          this.dataCount.emit(this.accountsAndContactsStats);
        }else{
          this.dataCount.emit([0,0]);
        }
        const duplicates = this.findDuplicates(this.dataSource.data);
        const emptyFields = this.findEmpties(this.dataSource.data);
        if(duplicates.length > 0 || emptyFields.length > 0){
          this.isWarn.emit(true);
        }else{
          this.isWarn.emit(false);
        }
      }
    });
  }

  handleChecked(row: any) {
    if (!row.disabled) {
      this.selection.toggle(row);
    }
  }

  expandToggle(element: any) {    
    this.expandedElement = this.expandedElement !== element && !element.disabled ? element : null;   
  }

  isExpanded(row: any) {
    return row === this.expandedElement;
  }

  public isDuplicated(d: any, target: any): boolean{
    if(!d || !target) return false;
    return this.isDuplicatedEmail(d, target) || this.isDuplicatedName(d, target);
  }

  public isDuplicatedEmail(d: any, target: any): boolean{
    if(!d || !target) return false;
    const targetIndex = d.indexOf(target);
    return d.some((obj, index) => 
      index !== targetIndex && 
      obj.customerId === target.customerId &&
      obj.customerEmail === target.customerEmail);
  }

  public isDuplicatedName(d: any, target: any): boolean{
    if(!d || !target) return false;
    const targetIndex = d.indexOf(target);
    return d.some((obj, index) => 
      index !== targetIndex && 
      obj.customerId === target.customerId && 
      obj.customerName !== target.customerName);
  }

  public findDuplicates(arr) {
    return arr.filter((target, index) => {
      return (
        arr.some((obj, targetIndex) => 
        index !== targetIndex && 
        obj.customerId === target.customerId &&
        obj.customerEmail === target.customerEmail)
      )
      || (
        arr.some((obj, targetIndex)  => 
        index !== targetIndex && 
        obj.customerId === target.customerId && 
        obj.customerName !== target.customerName)
      ) ;
    });
  }
    public findEmpties(arr) {
      return arr.filter((i)=>{
        if(
          i.customerContactName === undefined || i.customerContactName === '' || i.customerContactName === null ||
          i.customerEmail === undefined || i.customerEmail === '' || i.customerEmail === null ||
          i.customerId === undefined || i.customerId === '' || i.customerId === null ||
          i.customerName === undefined || i.customerName === '' || i.customerName === null ||
          i.sourceName === undefined || i.sourceName === '' || i.sourceName === null
        ){
          return true;
        }
      })
    }

  public btnImportClicked(): void {
    this.isImportBtnExpanded = !this.isImportBtnExpanded;
  }

  public fromRexisSap(){
    this.isImportBtnExpanded = false;
    const dialogRef = this.dialog.open(RexisSapDialogComponent,{
      disableClose: true,
      autoFocus: true,
      panelClass: 'rexisPopup'
    });
    dialogRef.afterClosed().subscribe(resData => {
      const rexSapDataSelected = resData;
      if(rexSapDataSelected && rexSapDataSelected !== 'cancel'){
        this.dataSource.data = [
          ...this.dataSource.data,
          ...rexSapDataSelected.map(data => {
            return {
              customerId: data.erpAccountNo.trim(),
              customerName: data.accountName.trim() || data.name.trim(),
              customerContactName: data.contactName.trim(),
              customerEmail: data.contactEmail.trim(),
              sourceName: 'Rexis/SAP'
            };
          })
        ];
        if(this.dataSource.data.length <= this.contactLimitNumber){
          this.isLimit.emit(false);
        }else{
          this.isLimit.emit(true);
        }
        if(this.dataSource.data.length>0){
          const allAccounts = this.dataSource.data.map(i => i.customerId);
          this.mainAccounts = [...new Set(allAccounts)];
          this.accountsAndContactsStats=[this.dataSource.data.length,this.mainAccounts.length]
          this.dataCount.emit(this.accountsAndContactsStats);
        }else{
          this.dataCount.emit([0,0]);
        }
        const duplicates = this.findDuplicates(this.dataSource.data);
        const emptyFields = this.findEmpties(this.dataSource.data);
        if(duplicates.length > 0 || emptyFields.length > 0){
          this.isWarn.emit(true);
        }else{
          this.isWarn.emit(false);
        }
        this.recipientsFilterService.setSourceName('Rexis/SAP');
        this.sourceNameForStore = Object.assign([], this.sourceNameForStore);
        let sourceEle = {label: 'Rexis/SAP', value: 'Rexis/SAP'};
        if (sourceEle.label !== '') {
            let checkEle = true;
            this.sourceNameForStore.some((el) => {
              if (el.label.trim().toLowerCase() === sourceEle.label.trim().toLowerCase()) {
                checkEle = false;
              }
            });
            if (checkEle) this.sourceNameForStore.push(sourceEle);
        }      
        this.tableData = this.dataSource.data;
        this.addProduct(this.dataSource.data,this.sourceNameForStore);
        if (this.dataSource.data.length > 0) {
          this.oneSnackBar.open('Recipient list imported successfully', OneSnackBarType.SUCCESS);
        }
      }else if(rexSapDataSelected === 'cancel'){
        console.log('cancel');
      }else {
        this.oneSnackBar.open('There is some problem with recipient list', OneSnackBarType.WARNING);
      }
    });
  }

  isEmpty(data){
    if (data.customerContactName === undefined || data.customerContactName === '' || data.customerContactName === null ||
          data.customerEmail === undefined || data.customerEmail === '' || data.customerEmail === null ||
          data.customerId === undefined || data.customerId === '' || data.customerId === null ||
          data.customerName === undefined || data.customerName === '' || data.customerName === null ||
          data.sourceName === undefined || data.sourceName === '' || data.sourceName === null){
          return true
    }
    return false
  }

  announceSortChange(sortState: Sort) {
      if (sortState.direction) {
        this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
      } else {
        this._liveAnnouncer.announce('Sorting cleared');
      }
  }

  trimSpaces(data){
    data.map(i=>{
      if(i.customerContactName!==undefined || '' || null){
        i.customerContactName=i.customerContactName.trim()
      } 
      if(i.customerEmail!==undefined || '' || null){
        i.customerEmail=i.customerEmail.trim()
      } 
      if(i.customerId!==undefined || '' || null){
        i.customerId=i.customerId.trim()
      }
      if(i.customerName!==undefined || '' || null){
        i.customerName=i.customerName.trim()
      }
      if(i.sourceName!==undefined || '' || null){
        i.sourceName=i.sourceName.trim()
      }
    })
  }

}
